import TicketTypeIcon from "app/components/TicketTypeIcon";
import CustomTooltip from "app/components/Tooltip";
import CommonTicketTypeSelection from "app/containers/Features/components/CommonTicketTypeSelection";
import { ITicketTypes } from "app/containers/Features/containers/TeamSettings/container/Projects/container/WorkItems/types";
import React, { useMemo } from "react";
import { getTicketTypeByIds } from "../../../TeamSettings/container/Projects/container/WorkItems/helper";

interface CustomProps {
  type: string;
  setValue: (val: string) => void;
  ticketTypes: ITicketTypes[];
  onOpen: () => void;
  onClose: () => void;
}

const TypeSelection: React.FC<CustomProps> = ({
  type,
  setValue,
  ticketTypes,
  onOpen,
  onClose,
}) => {
  const ticketType = useMemo(() => {
    return getTicketTypeByIds(ticketTypes, type)[0];
  }, [ticketTypes, type]);
  const updateValue = (data: ITicketTypes) => {
    setValue(data._id);
  };

  return (
    <>
      <CommonTicketTypeSelection
        trigger={
          <button className="flex items-center justify-between w-full p-[6px] rounded-md hover:bg-[#F4F5F7] rounded-[4px] data-[state=open]:border-[#79808A] data-[state=open]:outline-[#79808A] data-[state=open]:border-[1px] border-[#79808A]">
            <CustomTooltip
              text="Click to choose type"
              className="flex items-center gap-1 "
              position="left"
            >
              {ticketType ? (
                <div className="flex items-center gap-1 w-full">
                  <TicketTypeIcon
                    iconName={ticketType?.icon as string}
                    size={16}
                  />

                  <span className={`text-xs font-normal text-secondary`}>
                    {ticketType.name}
                  </span>
                </div>
              ) : (
                <span className="text-xs leading-[18px] font-normal text-secondary">
                  Choose ticket type
                </span>
              )}
            </CustomTooltip>
          </button>
        }
        align="center"
        setValue={updateValue}
        value={type}
        isHeader="Ticket Types"
        showEndIcon
        dropDownClassName=" min-w-[230px] "
        onOpen={onOpen}
        onClose={onClose}
      />
    </>
  );
};

export default TypeSelection;
